import { render, staticRenderFns } from "./ReportLearnPieChart.vue?vue&type=template&id=204e6c5a&"
import script from "./ReportLearnPieChart.vue?vue&type=script&lang=ts&"
export * from "./ReportLearnPieChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports